import axios, {AxiosError} from 'axios';
import {useUserStore} from '../stores/useUserStore';
const BASE_URL = process.env.REACT_APP_API_URL;

export const apiInstance = axios.create({
  baseURL: BASE_URL,
});

export const apiSecretInstance = axios.create({
  baseURL: BASE_URL,
});

apiSecretInstance.interceptors.request.use((config) => {
  const {user} = useUserStore.getState();
  console.log(user.token, 'token');

  if (user?.token) {
    config.headers['Authorization'] = `Bearer ${user.token}`;
  }
  console.log(config);

  return config;
});

apiSecretInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error instanceof AxiosError && error.response.status === 401) {
      useUserStore.getState().removeCredentials();
    }
    return Promise.reject(error);
  }
);
